import { DateInput } from 'framework/form';
import { EqCondition, useFilterContext } from 'framework/list';
import { FilterCondition } from 'framework/types';
import React from 'react';
import moment from 'moment';
import usePayrollService, { PAYROLL_PERIOD_FORMAT } from 'domain/finance/payroll/shared/payrollService';

const FILTER_ERROR = 'Please, choose the valid period in the past';

const PayrollPeriodFilter = ({ source }: { source: string }) => {
  const { filters, getFilterErrors, setFilterErrors } = useFilterContext();
  const { getMaximalAvailablePeriod } = usePayrollService();

  const validateAndShowErrorMessages = () => {
    const inputValue = filters && filters[source] && filters[source][FilterCondition.EQ];
    const date = moment(inputValue, PAYROLL_PERIOD_FORMAT, undefined, true);

    const isValid = inputValue && date.isValid() && date.isSameOrBefore(getMaximalAvailablePeriod());

    const showErrors = !isValid;
    if (showErrors) {
      setFilterErrors(source, FilterCondition.EQ, [FILTER_ERROR]);
    } else {
      setFilterErrors(source, FilterCondition.EQ, []);
    }
    return showErrors;
  };

  const getErrors = () => {
    return getFilterErrors(source, FilterCondition.EQ);
  };

  const maxDate = moment(getMaximalAvailablePeriod(), PAYROLL_PERIOD_FORMAT).endOf('month');

  return (
    <EqCondition source={source}>
      <DateInput
        isRequired
        dateFormat={PAYROLL_PERIOD_FORMAT}
        validationCallback={validateAndShowErrorMessages}
        errorMessages={getErrors()}
        maxDate={maxDate}
        source={source}
      />
    </EqCondition>
  );
};

export default PayrollPeriodFilter;
